import { createMuiTheme } from "@material-ui/core/styles";

import {
  blueLight,
  blue,
  blueDark,
  orangeLight,
  orange,
  orangeDark,
  greenLight,
  green,
  greenDark,
  redLight,
  red,
  redDark,
  greyLight,
  white,
} from "./variables";

export default createMuiTheme({
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          background: greyLight,
          backgroundColor: greyLight,
        },
      },
    },
    MuiDialogActions: {
      spacing: {
        "& > :not(:first-child)": { marginLeft: "16px" },
      },
    },
  },
  palette: {
    primary: {
      light: blueLight,
      main: blue,
      dark: blueDark,
    },
    secondary: {
      light: orangeLight,
      main: orange,
      dark: orangeDark,
      contrastText: white,
    },
    success: {
      light: greenLight,
      main: green,
      dark: greenDark,
    },
    error: {
      light: redLight,
      main: red,
      dark: redDark,
    },
    warning: {
      light: orangeLight,
      main: orange,
      dark: orangeDark,
    },
  },
  typography: {
    button: {
      textTransform: "none",
    },
  },
  props: {
    MuiInputLabel: {
      shrink: true,
    },
  },
});
